import React, { useState, useMemo } from "react";

export default function PainelGestao({
  estadias,
  apartamentosUnicos,
  dataLimiteCheckin,
  onSalvarDataLimite,
  onTipoQuartoChange,
  tipoQuartoDb = {},
  mensagemCarregamento,
  onSalvarMensagemCarregamento,
}) {
  // SUB-TABS INTERNAS DO ADMIN
  const [subAbaInterna, setSubAbaInterna] = useState("dashboard");

  // Filtros originais com o estado gerido agora por botões pílula
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroApt, setFiltroApt] = useState("Todos");
  const [filtroEstadoBotao, setFiltroEstadoBotao] = useState("Atuais"); // 'Todos', 'Atuais', 'Próximos', 'Antigos'
  const [tempData, setTempData] = useState(dataLimiteCheckin || "");
  const [tempMensagemCarregamento, setTempMensagemCarregamento] = useState(
    mensagemCarregamento || ""
  );

  // Estado temporário da aba de quartos
  const [tempQuartosInventario, setTempQuartosInventario] = useState({});
  const [salvandoQuartos, setSalvandoQuartos] = useState(false);

  // 1. FILTRAGEM MULTI-CRITÉRIO COM OS NOVOS BOTÕES DE ESTADO
  const estadiasFiltradas = useMemo(() => {
    return estadias.filter((item) => {
      const matchNome = item.nome
        .toLowerCase()
        .includes(filtroNome.toLowerCase());
      const matchApt = filtroApt === "Todos" || item.apt === filtroApt;

      let matchEstado = true;
      if (filtroEstadoBotao !== "Todos") {
        matchEstado = item.estadoEstadia === filtroEstadoBotao;
      }
      return matchNome && matchApt && matchEstado;
    });
  }, [estadias, filtroNome, filtroApt, filtroEstadoBotao]);

  // 2. CÁLCULO FINANCEIRO AUTOMÁTICO ADAPTATIVO
  const metricas = useMemo(() => {
    const totalInquilinos = estadiasFiltradas.length;
    const somaRendas = estadiasFiltradas.reduce(
      (acc, item) => acc + (item.renda || 0),
      0
    );

    return {
      inquilinos: totalInquilinos,
      volumeFinanceiro: somaRendas.toLocaleString("pt-PT", {
        style: "currency",
        currency: "EUR",
      }),
    };
  }, [estadiasFiltradas]);

  // 3. MAPEAR OS QUARTOS ÚNICOS PARA A SEGUNDA TAB
  const inventarioQuartosUnicos = useMemo(() => {
    const chavesVistas = new Set();
    const listaArr = [];

    estadias.forEach((item) => {
      const aptLimpo = String(item.apt).trim();
      const quartoLimpo = String(item.quarto).trim();
      if (!aptLimpo || !quartoLimpo || quartoLimpo === "-") return;

      const idInventarioChave = `${aptLimpo
        .toUpperCase()
        .replace(/[\s#]+/g, "")}_${quartoLimpo
        .toUpperCase()
        .replace(/[\s#]+/g, "")}`;

      if (!chavesVistas.has(idInventarioChave)) {
        chavesVistas.add(idInventarioChave);
        listaArr.push({
          idInventarioChave,
          aptOriginal: aptLimpo,
          quartoOriginal: quartoLimpo,
        });
      }
    });

    return listaArr.sort(
      (a, b) =>
        a.aptOriginal.localeCompare(b.aptOriginal) ||
        a.quartoOriginal.localeCompare(b.quartoOriginal)
    );
  }, [estadias]);

  const handleGuardarDataFiltro = () => {
    onSalvarDataLimite(tempData);
    alert("✔️ Filtro de Histórico Global atualizado!");
  };

  const handleGuardarMensagemCarregamento = () => {
    onSalvarMensagemCarregamento(tempMensagemCarregamento);
    alert("✔️ Frase do ecrã de arranque atualizada!");
  };

  const handleGuardarConfigQuartos = async () => {
    setSalvandoQuartos(true);
    try {
      for (const [chave, valor] of Object.entries(tempQuartosInventario)) {
        await onTipoQuartoChange(chave, valor);
      }
      setTempQuartosInventario({});
      alert("✔️ Tipologias guardadas com sucesso!");
    } catch (e) {
      alert("Erro ao guardar na Cloud.");
    }
    setSalvandoQuartos(false);
  };

  return (
    <div style={{ width: "100%", boxSizing: "border-box" }}>
      {/* SELETOR DE SUB-TABS DO ADMIN */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "10px",
        }}
      >
        <button
          onClick={() => setSubAbaInterna("dashboard")}
          style={{
            padding: "8px 16px",
            border: "none",
            background: subAbaInterna === "dashboard" ? "#2563eb" : "#f1f5f9",
            color: subAbaInterna === "dashboard" ? "#fff" : "#475569",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          📊 Indicadores & Contratos Ativos
        </button>
        <button
          onClick={() => setSubAbaInterna("quartos_config")}
          style={{
            padding: "8px 16px",
            border: "none",
            background:
              subAbaInterna === "quartos_config" ? "#2563eb" : "#f1f5f9",
            color: subAbaInterna === "quartos_config" ? "#fff" : "#475569",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          🛏️ Configuração de Quartos (Simples/Suite)
        </button>
      </div>

      {subAbaInterna === "dashboard" && (
        <>
          {/* Barra Azul Superior de Filtro Global */}
          <div
            style={{
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              padding: "16px",
              borderRadius: "8px",
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div>
              <strong style={{ color: "#1e40af", fontSize: "13px" }}>
                📊 Filtro de Histórico Global (Toda a APP)
              </strong>
              <div
                style={{ fontSize: "12px", color: "#475569", marginTop: "4px" }}
              >
                Apenas estadias com data de{" "}
                <strong>Check-in igual ou posterior</strong> à data selecionada
                aparecerão na app e nas limpezas.
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <input
                type="date"
                value={tempData}
                onChange={(e) => setTempData(e.target.value)}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  fontSize: "13px",
                }}
              />
              <button
                onClick={handleGuardarDataFiltro}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Definir Data
              </button>
            </div>
          </div>

          {/* Frase do ecrã de arranque */}
          <div
            style={{
              background: "#fdf2f8",
              border: "1px solid #fbcfe8",
              padding: "16px",
              borderRadius: "8px",
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div>
              <strong style={{ color: "#9d174d", fontSize: "13px" }}>
                🚀 Frase do Ecrã de Arranque
              </strong>
              <div
                style={{ fontSize: "12px", color: "#475569", marginTop: "4px" }}
              >
                Texto mostrado enquanto a app está a carregar, para todos os
                utilizadores.
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <input
                type="text"
                value={tempMensagemCarregamento}
                onChange={(e) => setTempMensagemCarregamento(e.target.value)}
                placeholder="A preparar as operações Coolivin..."
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  fontSize: "13px",
                  minWidth: "280px",
                }}
              />
              <button
                onClick={handleGuardarMensagemCarregamento}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#db2777",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Guardar Frase
              </button>
            </div>
          </div>

          {/* Grandes Indicadores Brancos */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "24px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                background: "#ffffff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                flex: 1,
                minWidth: "240px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
              }}
            >
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                INQUILINOS SELECIONADOS
              </span>
              <p
                style={{
                  margin: "6px 0 0 0",
                  fontSize: "36px",
                  fontWeight: "800",
                  color: "#2563eb",
                }}
              >
                {metricas.inquilinos}
              </p>
            </div>
            <div
              style={{
                background: "#ffffff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                flex: 1,
                minWidth: "240px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
              }}
            >
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                VOLUME MENSAL FILTRADO
              </span>
              <p
                style={{
                  margin: "6px 0 0 0",
                  fontSize: "36px",
                  fontWeight: "800",
                  color: "#16a34a",
                }}
              >
                {metricas.volumeFinanceiro}
              </p>
            </div>
          </div>

          {/* BARRA DE FILTROS INTERMÉDIOS COM NOVOS BOTÕES PILULA DE PERÍODO AGREGADOS */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f8fafc",
              padding: "16px",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "15px",
                flex: 2,
                flexWrap: "wrap",
              }}
            >
              <div style={{ minWidth: "200px", flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    marginBottom: "6px",
                  }}
                >
                  Procurar Inquilino:
                </label>
                <input
                  type="text"
                  placeholder="Procura por nome..."
                  value={filtroNome}
                  onChange={(e) => setFiltroNome(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    border: "1px solid #cbd5e1",
                    fontSize: "13px",
                    boxSizing: "border-box",
                  }}
                />
              </div>
              <div style={{ minWidth: "140px", flex: 0.6 }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    marginBottom: "6px",
                  }}
                >
                  Apartamento:
                </label>
                <select
                  value={filtroApt}
                  onChange={(e) => setFiltroApt(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "6px",
                    border: "1px solid #cbd5e1",
                    fontSize: "13px",
                    backgroundColor: "#fff",
                  }}
                >
                  <option value="Todos">Todos</option>
                  {apartamentosUnicos
                    .filter((a) => a !== "Todos")
                    .map((apt) => (
                      <option key={apt} value={apt}>
                        {apt}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* NOVOS BOTÕES PILULA INTERATIVOS PARA GESTÃO DE ESTADIA */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "6px" }}
            >
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#475569",
                }}
              >
                Estado da Estadia:
              </span>
              <div
                style={{
                  display: "flex",
                  gap: "6px",
                  background: "#fff",
                  padding: "4px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                }}
              >
                <button
                  type="button"
                  onClick={() => setFiltroEstadoBotao("Todos")}
                  style={{
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    backgroundColor:
                      filtroEstadoBotao === "Todos" ? "#2563eb" : "transparent",
                    color: filtroEstadoBotao === "Todos" ? "#fff" : "#475569",
                  }}
                >
                  Ver Todos
                </button>
                <button
                  type="button"
                  onClick={() => setFiltroEstadoBotao("Antigos")}
                  style={{
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    backgroundColor:
                      filtroEstadoBotao === "Antigos"
                        ? "#64748b"
                        : "transparent",
                    color: filtroEstadoBotao === "Antigos" ? "#fff" : "#475569",
                  }}
                >
                  ↩️ Passadas
                </button>
                <button
                  type="button"
                  onClick={() => setFiltroEstadoBotao("Atuais")}
                  style={{
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    backgroundColor:
                      filtroEstadoBotao === "Atuais"
                        ? "#16a34a"
                        : "transparent",
                    color: filtroEstadoBotao === "Atuais" ? "#fff" : "#475569",
                  }}
                >
                  ● Atuais
                </button>
                <button
                  type="button"
                  onClick={() => setFiltroEstadoBotao("Próximos")}
                  style={{
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                    backgroundColor:
                      filtroEstadoBotao === "Próximos"
                        ? "#0284c7"
                        : "transparent",
                    color:
                      filtroEstadoBotao === "Próximos" ? "#fff" : "#475569",
                  }}
                >
                  🔮 Futuras
                </button>
              </div>
            </div>
          </div>

          {/* Tabela de Detalhe Original */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              overflowX: "auto",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.02)",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "12.5px",
                textAlign: "left",
                minWidth: "1350px",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f8fafc",
                    borderBottom: "2px solid #e2e8f0",
                  }}
                >
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Apt
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Qto
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Inquilino
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Entrada Contrato
                  </th>
                  <th style={{ padding: "12px 14px", color: "#1d4ed8" }}>
                    Entrada Comunicada
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    ETA
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Saída Contrato
                  </th>
                  <th style={{ padding: "12px 14px", color: "#1d4ed8" }}>
                    Saída Comunicada
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Estado
                  </th>
                  <th
                    style={{
                      padding: "12px 14px",
                      color: "#16a34a",
                      textAlign: "right",
                    }}
                  >
                    Renda
                  </th>
                  <th
                    style={{
                      padding: "12px 14px",
                      color: "#475569",
                      textAlign: "right",
                    }}
                  >
                    1ª Renda
                  </th>
                  <th
                    style={{
                      padding: "12px 14px",
                      color: "#1d4ed8",
                      textAlign: "right",
                    }}
                  >
                    Depósito
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    Observações
                  </th>
                </tr>
              </thead>
              <tbody>
                {estadiasFiltradas.map((item) => (
                  <tr
                    key={item.id}
                    style={{ borderBottom: "1px solid #f1f5f9" }}
                  >
                    <td style={{ padding: "12px 14px", fontWeight: "700" }}>
                      {item.apt}
                    </td>
                    <td style={{ padding: "12px 14px", fontWeight: "600" }}>
                      {item.quarto}
                    </td>
                    <td style={{ padding: "12px 14px" }}>
                      <div style={{ fontWeight: "700", color: "#0f172a" }}>
                        {item.nome}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#64748b",
                          marginTop: "2px",
                        }}
                      >
                        {item.email}
                      </div>
                    </td>
                    <td style={{ padding: "12px 14px", color: "#334155" }}>
                      {item.entradaContrato}
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        color: "#0284c7",
                        fontWeight: "500",
                      }}
                    >
                      {item.entradaComunicada || "-"}
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        fontStyle: "italic",
                        color: "#64748b",
                      }}
                    >
                      {item.eta || "-"}
                    </td>
                    <td style={{ padding: "12px 14px", color: "#334155" }}>
                      {item.saidaContrato}
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        color: "#0284c7",
                        fontWeight: "500",
                      }}
                    >
                      {item.saidaComunicadaTexto || "-"}
                    </td>
                    <td style={{ padding: "12px 14px" }}>
                      <span
                        style={{
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor:
                            item.estadoEstadia === "Atuais"
                              ? "#dcfce7"
                              : item.estadoEstadia === "Próximos"
                              ? "#e0f2fe"
                              : "#fee2e2",
                          color:
                            item.estadoEstadia === "Atuais"
                              ? "#15803d"
                              : item.estadoEstadia === "Próximos"
                              ? "#0369a1"
                              : "#991b1b",
                        }}
                      >
                        {item.estadoEstadia === "Atuais"
                          ? "● Atual"
                          : item.estadoEstadia === "Próximos"
                          ? "🔮 Futura"
                          : "● Antigo"}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        textAlign: "right",
                        fontWeight: "700",
                        color: "#16a34a",
                      }}
                    >
                      {item.renda ? `${item.renda.toFixed(2)} €` : "-"}
                    </td>
                    <td style={{ padding: "12px 14px", textAlign: "right" }}>
                      -
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        textAlign: "right",
                        fontWeight: "600",
                        color: "#0284c7",
                      }}
                    >
                      {item.deposito ? `${item.deposito.toFixed(2)} €` : "-"}
                    </td>
                    <td
                      style={{
                        padding: "12px 14px",
                        color: "#475569",
                        fontSize: "12px",
                        maxWidth: "250px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={item.observacoes}
                    >
                      {item.observacoes || "-"}
                    </td>
                  </tr>
                ))}
                {estadiasFiltradas.length === 0 && (
                  <tr>
                    <td
                      colSpan="13"
                      style={{
                        padding: "40px",
                        textAlign: "center",
                        color: "#94a3b8",
                        fontWeight: "bold",
                      }}
                    >
                      Nenhum contrato ativo encontrado com estes critérios.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* VISTA 2: CONFIGURAÇÃO DE QUARTOS */}
      {subAbaInterna === "quartos_config" && (
        <div style={{ background: "#ffffff", padding: "10px 0" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
              Define a tipologia dos quartos. Carregará de forma automática na
              Escala de Limpeza.
            </p>
            <button
              onClick={handleGuardarConfigQuartos}
              disabled={salvandoQuartos}
              style={{
                padding: "10px 20px",
                backgroundColor: "#16a34a",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {salvandoQuartos ? "A Gravar..." : "💾 Guardar Tipologias"}
            </button>
          </div>
          <div
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "13px",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f8fafc",
                    borderBottom: "2px solid #e2e8f0",
                  }}
                >
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    🏢 Apartamento
                  </th>
                  <th style={{ padding: "12px 14px", color: "#475569" }}>
                    🔑 Número do Quarto
                  </th>
                  <th
                    style={{
                      padding: "12px 14px",
                      color: "#475569",
                      textAlign: "center",
                    }}
                  >
                    🛏️ Estado Atual
                  </th>
                  <th
                    style={{
                      padding: "12px 14px",
                      color: "#475569",
                      textAlign: "center",
                    }}
                  >
                    ⚙️ Alterar
                  </th>
                </tr>
              </thead>
              <tbody>
                {inventarioQuartosUnicos.map((quarto) => {
                  const valorNaCloud =
                    tipoQuartoDb[quarto.idInventarioChave] || "Simples";
                  const valorTemporario =
                    tempQuartosInventario[quarto.idInventarioChave] !==
                    undefined
                      ? tempQuartosInventario[quarto.idInventarioChave]
                      : valorNaCloud;
                  return (
                    <tr
                      key={quarto.idInventarioChave}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td style={{ padding: "10px 14px", fontWeight: "700" }}>
                        {quarto.aptOriginal}
                      </td>
                      <td style={{ padding: "10px 14px", fontWeight: "600" }}>
                        Quarto {quarto.quartoOriginal}
                      </td>
                      <td style={{ padding: "10px 14px", textAlign: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: "11px",
                            fontWeight: "bold",
                            backgroundColor:
                              valorNaCloud === "Suite" ? "#f3e8ff" : "#f1f5f9",
                            color:
                              valorNaCloud === "Suite" ? "#6b21a8" : "#475569",
                          }}
                        >
                          {valorNaCloud === "Suite" ? "👑 Suite" : "🛏️ Simples"}
                        </span>
                      </td>
                      <td style={{ padding: "10px 14px", textAlign: "center" }}>
                        <select
                          value={valorTemporario}
                          onChange={(e) =>
                            setTempQuartosInventario((prev) => ({
                              ...prev,
                              [quarto.idInventarioChave]: e.target.value,
                            }))
                          }
                          style={{
                            padding: "6px",
                            borderRadius: "5px",
                            border: "1px solid #cbd5e1",
                            width: "130px",
                          }}
                        >
                          <option value="Simples">Simples</option>
                          <option value="Suite">Suite</option>
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
